import { useEffect } from 'react';

/**
 * Close modal/dropdown when Escape key is pressed.
 * @param {boolean} isActive - Whether the modal/dropdown is open
 * @param {function} onClose - Callback to close (e.g. setIsOpen(false))
 */
export const useCloseOnEscape = (isActive, onClose) => {
  useEffect(() => {
    if (!isActive || !onClose) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isActive, onClose]);
};
